export default __webpack_public_path__ + "static/media/mana13.f9f55ba5.svg";